import Typography from 'typography';

export const headingFont = 'Cinzel';
export const bodyFont = 'Open Sans';
export const quoteFontSize = '14px';

const accentHue = 20;
export const linkColor = `hsl(${accentHue}, 70%, 56%)`;
export const linkHoverColor = `hsl(${accentHue}, 76%, 42%)`;
export const bodyBackgroundColor = `hsl(${accentHue}, 6%, 98%)`;
export const quoteBackgroundColor = `hsl(${accentHue}, 50%, 96%)`;

const headerFontColor = `hsl(${accentHue + 180}, 25%, 10%)`;
const bodyFontColor = `hsl(${accentHue + 180}, 15%, 20%)`;

const typography = new Typography({
  title: 'berenice',
  baseFontSize: '16px',
  baseLineHeight: 1.5,
  scaleRatio: 2.5,
  googleFonts: [
    {
      name: headingFont,
      styles: [
        '400',
      ],
    },
    {
      name: bodyFont,
      styles: [
        '400',
        '400i',
        '600',
        '600i',
      ],
    },
  ],
  headerFontFamily: [headingFont, 'serif'],
  headerWeight: '400',
  headerColor: headerFontColor,
  bodyFontFamily: [bodyFont, 'sans-serif'],
  bodyWeight: '400',
  bodyColor: bodyFontColor,
  overrideStyles: () => ({
    'body': {
      backgroundColor: bodyBackgroundColor,
      '-webkitFontSmoothing': 'antialiased',
      '-mozOsxFontSmoothing': 'grayscale',
    },
    'h1,h2': {
      '-webkitFontSmoothing': 'initial',
      '-mozOsxFontSmoothing': 'initial',
    },
    'h1': {
      textTransform: 'uppercase',
    },
    'h2': {
      textTransform: 'lowercase',
    },
    'h3,h4,h5,h6': {
      fontFamily: bodyFont,
      textTransform: 'uppercase',
      fontWeight: '600',
    },
    'a': {
      color: linkColor,
      textDecoration: 'none',
      '-webkitFontSmoothing': 'initial',
      '-mozOsxFontSmoothing': 'initial',
    },
    'a:hover,a:active': {
      color: linkHoverColor,
    },
  }),
});

export default typography;



// WEBPACK FOOTER //
// ./src/utils/typography.js